import { Separator } from "@/components/ui/separator";
import { useLang } from "@/i18n";

export const PageFooter = ({ compact = false }) => {
  const { t } = useLang();
  if (compact) {
    return (
      <div className="px-6 py-5 border-t border-[#e8e8e8] shrink-0" data-testid="sidebar-footer">
        <div className="flex items-center gap-2">
          <span className="fora-wordmark text-[26px] text-[#000]">
            F<span className="dot" />RA
          </span>
          <span className="text-[10px] text-[#555555] font-medium">
            by Master F&B
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="mt-10" data-testid="page-footer">
      <Separator className="bg-[#e8e8e8] mb-4" />
      <div className="space-y-1">
        <p className="text-[10px] text-[#555555] leading-relaxed">
          Master F&B d.o.o. &nbsp;|&nbsp; Vlaška ulica 79, 10000 Zagreb, Croatia &nbsp;|&nbsp; Email: info@master-fb.com
        </p>
        <p className="text-[10px] text-[#555555] leading-relaxed">
          MBS: 081326069 &nbsp;|&nbsp; OIB (VAT ID): 27008878697 &nbsp;|&nbsp; Registered at the Commercial Court in Zagreb.
        </p>
        <p className="text-[10px] text-[#555555] leading-relaxed">
          FORA by Master F&amp;B &nbsp;|&nbsp; {t("Confidential Internal Use Only")} &nbsp;|&nbsp;{" "}
          <a
            href="/#legal"
            onClick={(e) => {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent("fora-navigate", { detail: "legal" }));
            }}
            className="text-[#dd260e] hover:underline"
            data-testid="footer-legal-link"
          >
            {t("Legal & Confidentiality")}
          </a>
        </p>
      </div>
    </div>
  );
};
